module.exports = __webpack_public_path__ + "img/battery-full.336afe49.svg";